import { Link } from "../../util";
import { urls } from "../../../config/appConfig";

export default function GoogleMapsLink(props) {
  const { address } = props;

  return (
    <Link
      href={`${urls.googleMapsQuery}${encodeURIComponent(address)}`}
      isNewTab
    >
      {address}
    </Link>
  );
}
